import { render, staticRenderFns } from "./SearchbarAutocompleteSuggestion.vue?vue&type=template&id=cce04596&"
import script from "./SearchbarAutocompleteSuggestion.vue?vue&type=script&lang=ts&"
export * from "./SearchbarAutocompleteSuggestion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports